import { Component } from '@angular/core';
import { EmailTemplate } from '../../models/EmailTemplate/EmailTemplate-model';
import { Role } from '../../models/shared/role.model';

import { Router, ActivatedRoute, Params } from "@angular/router";

import { ToastsManager } from 'ng2-toastr/ng2-toastr';
//import { EmailTemplateService } from '../../../services/emailTemplate/action-emailTemplate.service';
//import { Customer } from '../../../models/customer/customer-model'
//import { CustomerService } from '../../../services/customer/customer.service';
//import { NgSelectModule, NgOption } from '@ng-select/ng-select';
import { NotificationService } from '../../services/notification/notification.service';
import { EmailTemplateService } from '../../services/EmailTemplate/EmailTemplate.service';
import { RoleService } from '../../services/role/role.service';
import { RolePermissionService } from '../../services/role/role-permission.service';
@Component({
  selector: 'app-edit-EmailTemplate',
  templateUrl: './edit-EmailTemplate.component.html',
  styleUrls: ['./edit-EmailTemplate.component.css']
})
/** create-action-emailTemplate component*/
export class EditEmailTemplateComponent {
  public emailTemplate = new EmailTemplate();
  public Roles: Role[];
  isDisable = true;
  public TemplateVariablesClass: any[] = [];
  public TriggerTemporary: any[] = [];
  public htmlContent: any;
  public TemplateVariablesClassName:string;
  i: number;
  configuration = {
    uiColor: '#ffffff',
    toolbarGroups: [{ name: 'clipboard', groups: ['clipboard', 'undo'] },
    { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
    { name: 'links' }, { name: 'insert' },
    { name: 'document', groups: ['mode', 'document', 'doctools'] },
    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
    { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
    { name: 'styles' },
    { name: 'colors' }],
    resize_enabled: false,
    removePlugins: 'save',
    extraPlugins: 'smiley,justify,indentblock,colordialog',
    colorButton_foreStyle: {
      element: 'font',
      attributes: { 'color': '#(color)' }
    },
    height: 188,
    removeDialogTabs: '',
    removeButtons: '',
    format_tags: 'p;h1;h2;h3;pre;div'
  }
  /** create-action-emailTemplate ctor */
  constructor(private readonly emailTemplateService: EmailTemplateService,
    private readonly notificationService: NotificationService,
    private readonly roleservices: RoleService,
    public toastr: ToastsManager,
    private readonly router: Router,
    private _avRoute: ActivatedRoute, private readonly rolePermissionService: RolePermissionService
  ) {
    this.rolePermissionService.GetRolePermissions("emailtemplate").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            if (this._avRoute.snapshot.params["id"]) {
              this.emailTemplate.RoleIds = new Array();
              this.emailTemplate.emailTemplateTriggerTo = "";
              this.TemplateVariablesClassName = "";
              this.emailTemplate.emailTemplateType = "";
              this.GetCustomerTypes();
              this.GetTemplateVariables();
              this.GetTriggerValues();
              setTimeout(() => { this.getEmailTemplateById(this._avRoute.snapshot.params["id"]) }, 1000);

            }
          }
          else {
            this.router.navigate(["/EmailTemplate-list"]);
          }
        }
        else {
          this.router.navigate(["/EmailTemplate-list"]);
        }
      }
    )
  }
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  ngOnInit() {
    this.dropdownList = [];
    this.selectedItems = [];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'roleID',
      textField: 'roleName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }
  onItemSelect(item: any) {
    
    
    //this.emailTemplate.emailTemplateRoleIds.push(item.roleID);
  }
  onSelectAll(items: any) {
    

  }
  GetCustomerTypes() {
    this.roleservices.GetActiveRoles().subscribe(
      data => {
        
        this.Roles = data;
      }
    )
  }
  GetTriggerValues() {
    this.emailTemplateService.getEmailTemplateTriggerTo().subscribe(
      data => {
        
        this.emailTemplate.TriggerTo = data;
        this.TriggerTemporary = data;

      }
    )
  }
  search(nameKey, myArray) {
    for (var i = 0; i < myArray.length; i++) {
      if (myArray[i].roleID.toString() === nameKey) {
        
        return myArray[i];
      }
    }
  }
  searchTriggerOn(nameKey, myArray) {
    for (var i = 0; i < myArray.length; i++) {
      if (myArray[i].id.toString() === nameKey) {
        
        return myArray[i];
      }
    }
  }
  getEmailTemplateById(id: string) {
    this.emailTemplateService.getEmailTemplateById(id).subscribe(
      data => {
        
        this.emailTemplate = data;
        var selectedItem = data.emailTemplateRoleIds.split(',');


        if (typeof this.emailTemplate.RoleIds == "undefined")
          this.emailTemplate.RoleIds = [];


        var result = this.searchTriggerOn(data.emailTemplateTriggerTo, this.TriggerTemporary);
        if (typeof this.emailTemplate.TriggerTo == "undefined")
          this.emailTemplate.TriggerTo = [];
        this.emailTemplate.TriggerTo = this.TriggerTemporary

        for (this.i = 0; this.i < selectedItem.length; this.i++) {
          var results = this.search(selectedItem[this.i], this.Roles);
          this.emailTemplate.RoleIds.push(results);
        }



        //for (this.i = 0; this.i < selectedItem.length; this.i++) {
        //  this.emailTemplate.RoleIds =.push({ roleID: selectedItem[this.i], roleName: "name" });

        //  //[this.i].roleID = selectedItem[this.i];

        //}

      }
    )
  }

  GetTemplateVariables() {
    this.emailTemplateService.getTemplateVariables().subscribe(
      data => {

        
        var unique = {};
        var distinct = [];
        for (var i in data) {
          if (typeof (unique[data[i].templateVariableClass]) == "undefined") {
            distinct.push(data[i]);
          }
          unique[data[i].templateVariableClass] = 0;
        }

        //var unique = [new Set(data.map(item => item.templateVariableClass))];
        this.TemplateVariablesClass = distinct;
      }
    )
  }



  AddVariable(name: string) {

    if (typeof (this.emailTemplate.emailTemplateContent) == 'undefined')
      this.emailTemplate.emailTemplateContent = "";
    this.emailTemplate.emailTemplateContent += ' ' + name;

  }
  GetTemplateVariableByClassName(name: string) {

    this.emailTemplateService.getTemplateVariablesByClass(name).subscribe(
      data => {

        this.emailTemplate.TemplateVariables = data;


      }
    )
  }
  onSubmit() {
    
    this.isDisable = false;
    this.emailTemplate;
    //var i= document.write(this.emailTemplate.emailTemplateRoleIds.roleID.join(","));
    this.emailTemplate.emailTemplateRoleIds = Array.prototype.map.call(this.emailTemplate.RoleIds, s => s.roleID).toString();
    this.emailTemplateService.updateEmailTemplate(this.emailTemplate).subscribe(
      data => {

        if (data) {
          this.toastr.success('Email Template has been Updated.', 'Success');
          setTimeout(() => {
            this.router.navigate(["/EmailTemplate-list"]);
          }, 2000);
        }
        else {
          this.toastr.error('Error occurred. Please try again', 'Error');

        }

      });
    //this.EmailTemplateService.AddEmailTemplate(this.emailTemplate);
  }
}



// WEBPACK FOOTER //
// ./src/app/EmailTemplate/edit-EmailTemplate/edit-EmailTemplate.component.ts